import { Validators } from "@angular/forms";
import { LayerType, sharedForms } from "../layer.model";
import { ColorOverlayProperties, FormType, Properties } from "../properties.model";

export const colorOverlayForm: Properties = {
  propertyType: LayerType.Buildings,
  label: 'Building Layer',
  forms:
    sharedForms.concat([
    {
      id: ColorOverlayProperties.ColorOverlayColor,
      label: 'Color',
      type: FormType.Color,
      placeholder: "#Hex Color",
      defaultValue: '#FF0000',
      validators: [Validators.required, Validators.min(1)],
    },
  ]),
  changeHandler: () => {}
}
